"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
exports.auth = {
    auth_title: "Регистрация",
    auth_defaultMessage: "Войдите в аккаунт,\n чтобы продолжить",
    auth_phoneCodeError: "Код должен содержать 6 цифр",
    auth_codeLabel: "Код подтверждения",
    auth_register: "Регистрация",
    auth_sendCode: "Отправить код",
    auth_sendCodeAgain: "Отправить код еще раз",
    auth_sendCodeAgainTimeout: "Отправить снова через {0}",
    auth_registered: "Уже зарегистрирован",
    auth_codeSending: "Отправка кода подтверждения...",
    auth_codeSended: "Введите код, отправленный	на номер\n {0}",
    auth_codeApproved: "Код подтвержден! Идет авторизация",
    auth_codeChecking: "Проверка кода...",
    auth_tooManyRequests: "Запросы с этого устройства были заблокированы из-за необычной активности. Повторите попытку позже.",
    auth_captchaCheckFailed: "Ответ reCAPTCHA недействительный/истек срок действия.",
    auth_invalidPphoneNumber: "Номер телефона имеет недопустимый формат.",
    auth_quotaExceeded: "Превышена квота SMS.",
    auth_userDisabled: "Пользователь, соответствующий данному номеру телефона заблокирован.",
    auth_invalidVerificationCode: "Неверный код подтверждения SMS.",
    auth_unknown: "Неизвестная ошибка. Повторите попытку позже.",
    auth_expiredActionCode: "Действие кода истекло. Повторите попытку позже.",
    auth_merge: "Пользователь с этим телефоном уже зарегистрирован. Вам выслан новый код. Чтобы войти, введите новый код.",
    auth_sessionExpired: "Действие кода истекло. Повторите попытку позже.",
    auth_codeExpired: "Действие кода истекло. Повторите попытку позже.",
    auth_internalError: "Неизвестная ошибка. Повторите попытку позже.",
    auth_missingPhoneNumber: "Для отправки кода укажите корректный номер телефона.",
};
//# sourceMappingURL=auth.js.map